import { supabase } from '../config/supabase'
import { getSelectedSalonId } from '../utils/salonScope'

/**
 * Fetch tax policy for the selected salon.
 */
export const getTaxPolicy = async () => {
  try {
    const salonId = getSelectedSalonId()
    if (!salonId) {
      return { enabled: false, percentage: 0 }
    }

    const { data, error } = await supabase
      .from('tax_policies')
      .select('tax_percentage, tax_enabled')
      .eq('salon_id', salonId)
      .limit(1)

    if (error) {
      console.error('❌ Error fetching tax policy:', error)
      return { enabled: false, percentage: 0 }
    }

    const row = Array.isArray(data) ? data[0] : data
    if (!row || !row.tax_enabled) {
      // No row or disabled -> no tax
      return { enabled: false, percentage: 0 }
    }

    const percentageNumber = Number(row.tax_percentage)
    return {
      enabled: true,
      percentage: Number.isFinite(percentageNumber) ? percentageNumber : 0
    }
  } catch (error) {
    console.error('❌ Exception in getTaxPolicy:', error)
    return { enabled: false, percentage: 0 }
  }
}

